export const blogPosts= {
  "my-first-blog-post" : { 
    title: "My First Blog Post", 
    slug:"my-first-blog-post", 
    imgUrl:"https://assets-global.website-files.com/6132fbe8ffbafa06ae11e9ed/65f41822ad7519ededb867b9_IMG_3196-min-p-500.jpg",
    content: "This is my first blog post. Welcome!"},

  "my-second-blog-post" : {
    title: "My Second Blog Post", 
    slug:"my-second-blog-post", 
    imgUrl:"https://assets-global.website-files.com/6132fbe8ffbafa06ae11e9ed/65f418983c1d29a367a1e6e7_1000006988-p-500.jpg",
    content: "This is my second blog post. Woohoo"
  },
}